import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Facet, OccProductSearchAdapter } from '@spartacus/core';
import { FacetListComponent, FacetService, ProductListComponentService, } from '@spartacus/storefront'
import { map, Observable, of, Subject, takeUntil } from 'rxjs';
import { CategoryPageService } from 'src/app/customServices/category-page.service';
import { GetDocumentService } from 'src/app/customServices/get-document.service';
import { ProductListService } from 'src/app/services/feature/product-list.service';
@Component({
  selector: 'app-facet-list-kb',
  templateUrl: './facet-list-kb.component.html',
  styleUrls: ['./facet-list-kb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FacetListKbComponent extends FacetListComponent implements OnInit {
  categoryHeading: any;
  result: Observable<boolean>;
  isCategoryPresnet: number;
  facetTabIndex: any = 0;
  query: any;
  searchQuery: string;
  categoryFacetData$: Observable<any>;
  isCategeoryPage: boolean;
  docOrSoftware: boolean = false;

  productUrlsMap: { [key: string]: Observable<string> } = {};
  private readonly destroy$ = new Subject<void>();
  constructor(
    facetService: FacetService,
    elementRef: ElementRef,
    renderer: Renderer2,
    public productListService: ProductListService,
    public searchService: OccProductSearchAdapter,
    private activatedRoute: ActivatedRoute,
    public CategoryService: CategoryPageService,
    public productListComponentService: ProductListComponentService,
    private cdr: ChangeDetectorRef,
    private documentService: GetDocumentService,

  ) {
    super(facetService, elementRef, renderer);
  }
  override ngOnInit() {

    this.docOrSoftware = false;
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.isCategoryPresnet = data?.['categoryCode'];
      if (this.isCategoryPresnet != undefined) {
        this.categoryFacetData$ = this.CategoryService.model$;
        this.isCategeoryPage = true;
      }
      else {
        super.ngOnInit();
        this.productListService.selectedTabIndex.pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.facetTabIndex = data;
          if (this.facetTabIndex == 7 || this.facetTabIndex == 8 || this.facetTabIndex == 9 || this.facetTabIndex == 10) {
            this.docOrSoftware = true;
            this.cdr.detectChanges();
          }
        });
        this.isCategeoryPage = false;
      }
    });


    this.categoryFacetData$?.pipe(takeUntil(this.destroy$)).subscribe((model: any) => {
      if (model?.subCategories) {
        model.subCategories.forEach((product: any) => {
          if (!this.productUrlsMap[product?.url]) {
            this.productUrlsMap[product.url] = this.getProductUrl(product);
          }
        });
      }
    });

  }

  getProductUrl(product: any): Observable<string> {
    if (product.code === 'NA-000-006-002-003-002') {
      return this.documentService.getDocumentByDocumentCode('BW8223').pipe(
        map((response: { url: string }) => response.url)
      );
    }

    return of(product.url);
  }

  override ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}




